import { render, staticRenderFns } from "./hall.vue?vue&type=template&id=31e10a9a&scoped=true&"
import script from "./hall.vue?vue&type=script&lang=js&"
export * from "./hall.vue?vue&type=script&lang=js&"
import style0 from "./hall.vue?vue&type=style&index=0&id=31e10a9a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e10a9a",
  null
  
)

export default component.exports